import { render, staticRenderFns } from "./Telephone.vue?vue&type=template&id=0b4be070&scoped=true"
import script from "./Telephone.vue?vue&type=script&lang=js"
export * from "./Telephone.vue?vue&type=script&lang=js"
import style0 from "./Telephone.vue?vue&type=style&index=0&id=0b4be070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4be070",
  null
  
)

export default component.exports